export default "__VITE_ASSET__CwUnjzmZ__"